module.exports = __webpack_public_path__ + "3405c896c7ca8f4e13e2e23870f09110.png";